import { Component, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AuthGuardAdmin } from "lib-trend-core";
import { KanbanComponent } from "./kanban.component";
import { ProductComponent } from "./product/product.component";
import { CustomerComponent } from "./customer/customer.component";
import { LeadQualityConfigComponent } from "./lead-quality-config/lead-quality-config.component";
import { CrmListsConfigComponent } from "./crm-lists-config/crm-lists-config.component";
import { LossReasonComponent } from "./loss-reason/loss-reason.component";

const routes = [
  // Deep link to a card: `/kanban?card=<id>` — KanbanComponent opens the
  // details DIALOG. `card/:id` used to mount CardDetailsComponent (a dialog
  // component) as a routed page, which rendered an empty shell because
  // MAT_DIALOG_DATA is never provided by the router.
  { path: '', component: KanbanComponent, data: { hideFooter: true } },
  { path: 'product', component: ProductComponent },
  { path: 'customer', component: CustomerComponent },
  { path: 'loss-reason', component: LossReasonComponent },
  // ADMIN-only: `PUT /api/company/lead-quality` answers 403 to everyone else
  // (company.controller.ts), while the parent /kanban route only requires
  // AuthGuardAttendant. AuthGuardAdmin tests `roles.includes(ADMIN)` — the same
  // rule the API enforces, and NOT the exact-set `isAdmin()`.
  { path: 'lead-quality', component: LeadQualityConfigComponent, canActivate: [AuthGuardAdmin] },
  // Same guard: `PUT /api/company/crm-lists` is admin-only (E2 RF-09).
  { path: 'crm-lists', component: CrmListsConfigComponent, canActivate: [AuthGuardAdmin] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KanbanRoutingModule { }
